import { CSI } from '@devdept/csi';
import { TStand } from '@devdept/csi/dist/types';
import { TAppVersion } from 'api/types';
import { CSI_PROJECT_NAME } from 'constants/common';
import { getLocalStorage } from 'helpers';
import store from 'store';
import { selectEnabled } from 'store/common/toggle';
import { getStandFromEnv } from './stand';

const standMap: Record<TAppVersion, TStand> = {
  DEV: 'local',
  PROD: 'production',
  STAGE: 'stage',
  E2E: 'stage',
};
export const pushCSITrigger = (username: string, trigger?: string) => {
  const isEnabled = selectEnabled('csi')(store.getState());
  if (!isEnabled) return;
  const stand = getStandFromEnv();

  return CSI({
    projectName: CSI_PROJECT_NAME,
    stand: standMap[stand],
    jwt: () => getLocalStorage<{ access: string }>('jwt_auth')?.access ?? '',
  })(username, trigger);
};
